import css from './GalleryWrapper.module.scss'
import React, { PropsWithChildren, useLayoutEffect, useState } from 'react'
import classNames from 'classnames'

type Props = PropsWithChildren<{
  opened: boolean
}>

const GalleryWrapper: React.FC<Props> = (props) => {
  const { children, opened: openedProps } = props

  const [opened, setOpened] = useState(false)

  useLayoutEffect(() => {
    setOpened(openedProps)
  }, [openedProps])

  return <div className={classNames(css.galleryWrapper, { [css.opened]: opened })}>{children}</div>
}

export default GalleryWrapper
